// Plausible custom events. The Plausible snippet in public/index.html defines window.plausible and
// queues calls until its script has loaded; ad blockers can remove it, so a missing function is fine.
export const EVENTS = Object.freeze({
  urlSubmitted: 'URL submitted',
  fullReportRequested: 'Full report requested',
  assetGeneratorError: 'Asset generator error',
  fullReportFromEmail: 'Full report opened from email',
  extensionScored: 'Extension scored'
})

// Added to the result link in the email, so a visit from that link can be told apart from a shared link.
export const EMAIL_SOURCE_QUERY = Object.freeze({ key: 'source', value: 'email' })

export function trackEvent (name, props) {
  if (typeof window.plausible !== 'function') return
  window.plausible(name, props ? { props } : undefined)
}

// The status of a failed asset-generator request, or "network" when there was no response.
export const errorStatus = (error) => String(error?.response?.status ?? 'network')
